/*
 * The Private License
 *
 * Copyright (c) 2023 Mahon Media LLC.
 */

/**
 * Is availability enough?
 * @param availability availability JSON
 * @returns {*} boolean value
 */
export function enoughAvailability(availability) {
  return availability.every(
    inventory =>
      inventory.availableCount >= inventory.requiredAvailable
  );
}
